// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const CategoryProducstsList = registerClientReference(
    function() { throw new Error("Attempted to call CategoryProducstsList() from the server but CategoryProducstsList is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/e-commerce/category/products-list/index.tsx",
    "CategoryProducstsList",
);
